import { type RoleKeys, setAnalyticsUser } from "analytics";
import { ToastMethods } from "components/ToastNotification";
import { STM_ROUTE } from "constants/routes";
import i18n from "i18n";
import { action, observable } from "mobx";
import type { Book } from "models/book/Book";
import type { User } from "models/user/User";
import { accountRepository } from "repositories";

interface ProfileInterface {
  userInfo: User;
  setUserInfo: (userInfo: User) => void;
  fetchUserInfo: () => void;
  fetchLicenses: (additionalsId: string) => void;
}

const store = observable({
  setUserInfo: action((userInfo: User) => {
    store.userInfo = userInfo;
  }),
  fetchUserInfo: action(() => {
    accountRepository
      .getUserInfo()
      .then((currentUser: User) => {
        if (!store.userInfo) {
          setAnalyticsUser(currentUser.id, currentUser.role as RoleKeys);
        }
        store.setUserInfo(currentUser);
      })
      .catch(() => {
        ToastMethods.showToast(i18n.t("toast:profile.error.fetchUserInfo"), "error");
      });
  }),
  fetchLicenses: action((bookId: string) => {
    accountRepository
      .getLicenses()
      .then((data: Book[]) => {
        const bookIds = data.map((license: Book) => license.id);
        const hasLicense = bookIds.includes(bookId);
        if (!hasLicense) {
          ToastMethods.showToast(i18n.t("toast:profile.error.licensePermissions"), "error");
          setTimeout(() => {
            window.location.href = STM_ROUTE;
          }, 1500);
        }
      })
      .catch(() => {
        ToastMethods.showToast(i18n.t("toast:profile.error.fetchLicenses"), "error");
        setTimeout(() => {
          window.location.href = STM_ROUTE;
        }, 1500);
      });
  }),
} as ProfileInterface);

export const useProfile = (): ProfileInterface => store;
